import { fetchQuery } from "relay-runtime"
import type { useChBetterDocUsageForConsultationQuery } from "@/modules/patients/detail/better-doc/ch/services/__generated__/useChBetterDocUsageForConsultationQuery.graphql"
import { chBetterDocUsageForConsultationQuery } from "@/modules/patients/detail/better-doc/ch/services/useChBetterDocUsageForConsultationQuery"
import type { useDeBetterDocUsageForConsultationQuery } from "@/modules/patients/detail/better-doc/de/services/__generated__/useDeBetterDocUsageForConsultationQuery.graphql"
import { deBetterDocUsageForConsultationQuery } from "@/modules/patients/detail/better-doc/de/services/useDeBetterDocUsageForConsultationQuery"
import { RelayEnvironment } from "@/relay-environment"
import type { BetterDoc, BetterDocConsultationDetail, Country } from "@/types/__generated__/union-types"

type BetterDocUsageForConsultationVariables = useChBetterDocUsageForConsultationQuery["variables"]

export type BetterDocUsageEvaluation = {
  betterDocUsage: BetterDoc
  missingConsultationDetailsThatCanChangeBetterDocUsage: ReadonlyArray<BetterDocConsultationDetail>
}

export const fetchBetterDocUsageForConsultation = async (
  country: Country,
  variables: BetterDocUsageForConsultationVariables,
): Promise<BetterDocUsageEvaluation | undefined> => {
  const result =
    country === "CH"
      ? await fetchQuery<useChBetterDocUsageForConsultationQuery>(
          RelayEnvironment,
          chBetterDocUsageForConsultationQuery,
          variables,
        ).toPromise()
      : await fetchQuery<useDeBetterDocUsageForConsultationQuery>(
          RelayEnvironment,
          deBetterDocUsageForConsultationQuery,
          variables,
        ).toPromise()

  if (!result) return undefined

  return {
    betterDocUsage: result.betterDocUsageForConsultation,
    missingConsultationDetailsThatCanChangeBetterDocUsage: result.missingConsultationDetailsThatCanChangeBetterDocUsage,
  }
}
